import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { IInputProps } from './IInputProps';

const Input = React.forwardRef<HTMLInputElement, IInputProps>(
  (props: IInputProps, forwardRef) => {
    const {
      trailingIcon: TrailingIcon = null,
      prefixIcon: PrefixIcon = null,
      labelChildren: LabelChildren = null,
      className,
      isRequired,
      containerClassName,
      ...rest
    } = props;

    const classes = twMerge(
      clsx({
        'block w-full px-4 placeholder:text-mobile-gray-400 py-[14px] disabled:bg-gray-50 text-gray-600 focus:border-mobile-gray-100 rounded-lg border-mobile-gray-100 sm:text-sm focus:text-gray-900 focus:ring-0':
          true,
        'pl-12': PrefixIcon !== null,
        'rounded-l-md': PrefixIcon !== null,
        'pr-12': TrailingIcon !== null,
      }),
      className
    );

    return (
      <div className="w-full">
        <label
          htmlFor={rest.id}
          className={clsx({
            'block text-sm font-medium text-mobile-gray-500': true,
            "after:content-['*'] after:text-primary-500": isRequired === true,
          })}
        >
          {LabelChildren || null}
        </label>
        <div
          className={twMerge(
            containerClassName,
            clsx({
              'border-mobile-gray-100 relative rounded-lg border': true,
              'mt-2': LabelChildren,
            })
          )}
        >
          {PrefixIcon ? (
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              {PrefixIcon}
            </div>
          ) : null}
          <input type="text" className={classes} ref={forwardRef} {...rest} />
          {TrailingIcon ? (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3">
              {TrailingIcon}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
